import { forwardRef } from 'react';
import { Button as TamaguiButton, type TamaguiElement, XStack, YStack } from 'tamagui';
import Icon from '../../Icon/Icon';

type Props = {
  children: React.ReactNode;
  isOpen: boolean;
};

const CustomSelectedItemWrapper = forwardRef<TamaguiElement, Props>(({ children, isOpen, ...restProps }, ref) => {
  return (
    <TamaguiButton
      ref={ref}
      height="auto"
      borderRadius={0}
      borderWidth={0}
      p="$0"
      focusStyle={{
        borderWidth: 0,
        backgroundColor: '$transparent',
      }}
      testID="select-listbox-button"
      {...restProps}
    >
      <XStack display="block" flex={1} position="relative">
        {children}

        <YStack position="absolute" top={0} right={8 * 2} height="100%" jc="center">
          <Icon icon={isOpen ? 'chevronUp' : 'chevronDown'} size={8 * 2} color="$darkGray" />
        </YStack>
      </XStack>
    </TamaguiButton>
  );
});

export default CustomSelectedItemWrapper;
